import { createContext } from 'react';
import { Session } from './types';

interface HeaderContextInterface {
  isEUDC: boolean;
  lang: string;
  session?: Session;
}

const defaultHeaderCtx = {
  isEUDC: false,
  lang: 'en',
  session: undefined,
};

const HeaderContext = createContext<HeaderContextInterface>(defaultHeaderCtx);

export default HeaderContext;
